import { useContext } from "react";
import { assetContext } from "./AssetProvider";

export const useAsset = () => {
    return useContext(assetContext);
};
